import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Table from "react-bootstrap/Table";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import QuestionMarkOutlinedIcon from "@mui/icons-material/QuestionMarkOutlined";

import { Common, Subjects } from "../../../../helper";
import { isEmptyArray, isEmptyObject } from "../../../../util";
import { LoadingSpinner } from "../../../Shared";
import { PieCharts } from "./";
import * as markingApi from "../../../../api/markingApi";

import "../../../../assets/stlyes/SubjectOverView/OverallProgressTable.scss";

const Progress = () => {
  const [result, setResult] = useState();
  const [average, setAverage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const markingData = useSelector((state) => state.marking);
  const styleForm = {
    TrendsStyle: {
      borderRadius: "15px 0px 0px"
    },
    pieCells: {
      verticalAlign: "middle"
    }
  }
  const getSubjectAreaProgress = async () => {
    setIsLoading(true)
    const payload = {
      "classId": markingData.classId,
      "subjectName": markingData.subjectName,
      "year": markingData.year
    }

    if (payload.subjectName === Subjects.Empty) {
      switch (markingData.subjectId.slice(0, 2)) {
      case Subjects.WritingId:
        payload.subjectName = Subjects.Writing;
        break;
      case Subjects.MathId:
        payload.subjectName = Subjects.Maths;
        break;
      case Subjects.ReadingId:
        payload.subjectName = Subjects.Reading;
        break;
      case Subjects.ScienceId:
        payload.subjectName = Subjects.Science;
        break;
      case Subjects.PEId:
        payload.subjectName = Subjects.PE;
        break;
      default:
        break;
      }
    }

    const _fetchMarksbyPupilUpn = await markingApi.fetchMarksbyPupilUpn(payload);
    if (!isEmptyObject(_fetchMarksbyPupilUpn)) {
      setAverage(_fetchMarksbyPupilUpn.Items.classAverage)
      setResult(_fetchMarksbyPupilUpn.Items.pupil)
    }
    setIsLoading(false);
  }

  useEffect(() => {
    getSubjectAreaProgress();
  }, [markingData])

  useEffect(() => {
    getSubjectAreaProgress();
  }, [])

  const funCal = (a, b) => {
    if (a === "B") {
      if (b === "B") {
        return (
          <span className="chips" style={{ backgroundColor: "var(--expected-colour)" }}>
            <KeyboardArrowRightOutlinedIcon />
          </span>
        )
      }
      else {
        return (
          <span className="chips" style={{ backgroundColor: "var(--greater-colour)" }}>
            <ExpandLessIcon />
          </span>
        )
      }
    }
    else if (a === "L") {
      if (b === "B") {
        return (
          <span className="chips" style={{ backgroundColor: "var(--emerging-colour)" }}>
            <ExpandMoreOutlinedIcon />
          </span>
        )
      }
      else if (b === "W") {
        return (
          <span className="chips" style={{ backgroundColor: "var(--expected-colour)" }}>
            <KeyboardArrowRightOutlinedIcon />
          </span>
        )
      }
      else {
        return (
          <span className="chips" style={{ backgroundColor: "var(--greater-colour)" }}>
            <ExpandLessIcon />
          </span>
        )
      }
    }
    else if (a === "M") {
      if (b === "B" || b === "W") {
        return (
          <span className="chips" style={{ backgroundColor: "var(--emerging-colour)" }}>
            <ExpandMoreOutlinedIcon />
          </span>
        )
      }
      else if (b === "E") {
        return (
          <span className="chips" style={{ backgroundColor: "var(--expected-colour)" }}>
            <KeyboardArrowRightOutlinedIcon />
          </span>
        )
      }
      else {
        return (
          <span className="chips" style={{ backgroundColor: "var(--greater-colour)" }}>
            <ExpandLessIcon />
          </span>
        )
      }
    }
    else if (a === "H") {
      if (b === "B" || b === "W" || b === "E") {
        return (
          <span className="chips" style={{ backgroundColor: "var(--emerging-colour)" }}>
            <ExpandMoreOutlinedIcon />
          </span>
        )
      }
      else {
        return (
          <span className="chips" style={{ backgroundColor: "var(--expected-colour)" }}>
            <KeyboardArrowRightOutlinedIcon />
          </span>
        )
      }
    }
  }

  return (
    <>{isLoading ? <LoadingSpinner /> : <Table striped="columns" className="table-main">
      <thead>
        <tr>
          <th className="nameHeading" rowSpan={2}></th>
          <th rowSpan={2} className="tableHeaderTitleProgressTrends" style={styleForm.TrendsStyle}>{Common.Trends}</th>
          <th rowSpan={2} colSpan={2} >
            <tr>
              <th colSpan={2} className="tableHeaderTitleProgress">{Common.AllObjectives}</th>
            </tr>
            <tr>
              <th rowSpan={1} className="tableHeaderProgress">{Common.Current}</th>
              <th rowSpan={1} className="tableHeaderProgress">{Common.Predicted} </th>
            </tr>
          </th>
          <th rowSpan={2} colSpan={2} >
            <tr>
              <th colSpan={2} className="tableHeaderTitleProgress">{Common.KPIObjectives}</th>
            </tr>
            <tr>
              <th rowSpan={1} className="tableHeaderProgress">{Common.Current}</th>
              <th rowSpan={1} className="tableHeaderProgress">{Common.Predicted} </th>
            </tr>
          </th>
          <th rowSpan={2} colSpan={4} >
            <tr>
              <th colSpan={4} className="tableHeaderTitleProgress">{Common.ProgressOverTime}</th>
            </tr>
            <tr>
              {markingData.year>2 && <th rowSpan={1} className="tableHeaderProgress">{Common.KS1Result}</th>}
              <th rowSpan={1} className="tableHeaderProgress">{Common.GLD} </th>
              <th rowSpan={1} className="tableHeaderProgress">{Common.Prediction} </th>
              <th rowSpan={1} className="tableHeaderProgress">{Common.OnTrack} </th>
            </tr>
          </th>
        </tr>
      </thead>
      <tbody>
        {
          average && <tr>
            <td className="classAverageProgress">{Common.ClassAverage}</td>
            <td style={styleForm.pieCells}>
              {
                !isEmptyArray(average.pieChartAverage) ? <PieCharts pieResult={average.pieChartAverage} /> : <></>
              }
            </td>
            <td colSpan={2}>
              <td className="tableData">
                <div className="currentScore_ justify-content-center">
                  <span className="currentScorePercentage_">{average.actual == undefined ? 0 : Math.round(average.actual)}%</span>
                </div>
              </td>
              <td>
                <div className="predictedScore_ d-flex">
                  {average.predictedOutcome !== "" ? (<span className="predictedScoreMarking_" style={{ backgroundColor: average.predictedOutcome.charAt(1).toUpperCase() === "G" ? "var(--greater-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "E" ? "var(--expected-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "W" ? "var(--emerging-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "B" ? "var(--below-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "A" ? "var(--absent-colour)" : "#A8A7A7" }}><span className="predictedScoreMarkinText">{average.predictedOutcome.substr(0, 2)}</span></span>) : (<span className="predictedScoreMarking_" style={{ backgroundColor: "#A8A7A7" }}><span className="predictedScoreMarkinText">-</span></span>)}<span className="predictedScorePercentage">{average.predicted == undefined ? 0 : Math.round(average.predicted)}%</span>
                </div>
              </td>
            </td>
            <td colSpan={2}>
              <td className="tableData">
                <div className="currentScore_ justify-content-center">
                  <span className="currentScorePercentage_" >{average.actualKPI == undefined ? 0 : Math.round(average.actualKPI)}%</span>
                </div>
              </td>
              <td>
                <div className="predictedScore_ d-flex">
                  {average.kpiPredictedOutcome !== "" ? (<span className="predictedScoreMarking_" style={{ backgroundColor: average.kpiPredictedOutcome.charAt(1).toUpperCase() === "G" ? "var(--greater-colour)" : average.kpiPredictedOutcome.charAt(1).toUpperCase() === "E" ? "var(--expected-colour)" : average.kpiPredictedOutcome.charAt(1).toUpperCase() === "W" ? "var(--emerging-colour)" : average.kpiPredictedOutcome.charAt(1).toUpperCase() === "B" ? "var(--below-colour)" : average.kpiPredictedOutcome.charAt(1).toUpperCase() === "A" ? "var(--absent-colour)" : "#A8A7A7" }}><span className="predictedScoreMarkinText">{average.kpiPredictedOutcome.substr(0, 2)}</span></span>) : (<span className="predictedScoreMarking_" style={{ backgroundColor: "#A8A7A7" }}><span className="predictedScoreMarkinText">-</span></span>)}<span className="predictedScorePercentage">{average.predictedKPI == undefined ? 0 : Math.round(average.predictedKPI)}%</span>
                </div>
              </td>
            </td>
            <td>
              {markingData.year>2 && <td className="tableData">
                <td className="classHomeSubject-td">
                  <div className="KS-containerBox">
                    {average.ksResult !== "" ? (<div className="greenPointer_" style={{ backgroundColor: average.ksResult.charAt(average.ksResult.length - 1).toUpperCase() === "M" ? "var(--expected-colour)" : average.ksResult.charAt(average.ksResult.length - 1).toUpperCase() === "L" ? "var(--emerging-colour)" : average.ksResult.charAt(average.ksResult.length - 1).toUpperCase() === "H" ? "var(--greater-colour)" : average.ksResult.charAt(average.ksResult.length - 1).toUpperCase() === "B" ? "var(--below-colour)" : "#A8A7A7" }}></div>) : <div className="greenPointer_" style={{ backgroundColor: "#A8A7A7" }}></div>}
                    <span className="KS1">{average.ksResult !== "" ? average.ksResult : "-"}</span>
                  </div>
                </td>
              </td>}
              <td className="tableData">
                <td className="classHomeSubject-td">
                  <div className="KS-containerBox">
                    {/* <span className="KS1">{average.gld ? "true" : "false"}</span> */}
                  </div>
                </td>
              </td>
              <td className="tableData">
                <td className="classHomeSubject-td">
                  <div className="KS-containerBox">
                    {average.predictedOutcome !== "" ? (<div className="greenPointer_" style={{ backgroundColor: average.predictedOutcome.charAt(1).toUpperCase() === "G" ? "var(--greater-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "E" ? "var(--expected-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "W" ? "var(--emerging-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "B" ? "var(--below-colour)" : average.predictedOutcome.charAt(1).toUpperCase() === "A" ? "var(--absent-colour)" : "#A8A7A7" }}></div>) : (<div className="greenPointer_" style={{ backgroundColor: "#A8A7A7" }}></div>)}
                    <span className="KS1">{average.predictedOutcome === "" ? "-" : average.predictedOutcome.substr(0, 2)}</span>
                  </div>
                </td>
              </td>
              <td style={{ verticalAlign: "middle" }}>
                <div className="markingChipsProgress">
                  {
                    average.ksResult === "" || average.predictedOutcome === "" ? (<span className="chips" style={{ backgroundColor: "#A8A7A7" }}>
                      <QuestionMarkOutlinedIcon />
                    </span>) :
                      funCal(average.ksResult.charAt(average.ksResult.length - 1).toUpperCase(), average.predictedOutcome.charAt(1).toUpperCase())
                  }
                </div>
              </td>
            </td>
          </tr>
        }
        {result?.map((dat, i) => {
          return (
            <tr key={i}>
              <td className="nameInnerTextProgress">
                <span>{dat.firstName + " " + dat.lastName}</span>
                <div className=" d-flex flex-row">
                  {Object.entries(dat?.others).map(([key, value]) => {
                    if (value === true) {
                      return (
                        <div className="senStatus" key={i}>
                          <div className="dot" style={{ background: key === "pupilPremium" ? "#6D47FF" : "" || key === "eal" ? "#F4C900" : "" || key === "ehcp" ? "#F50057" : "" || key === "senStatus" ? "#F50057" : "" }}></div>
                          <span className="nameText">{key === "pupilPremium" ? "PP" : "" || key === "eal" ? "EAL" : "" || key === "senStatus" ? "SEND" : "" || key === "ehcp" ? "EHCP" : ""}</span>
                        </div>
                      )
                    }
                  })}
                </div>
              </td>
              <td style={styleForm.pieCells}>
                {
                  !isEmptyArray(dat.piechart) ? <PieCharts pieResult={dat.piechart} /> : <></>
                }
              </td>
              <td colSpan={2} >
                <td className="tableData">
                  <div className="currentScore_ justify-content-center">
                    <span className="currentScorePercentage_">{Math.round(dat.subject.actual)}%</span>
                  </div>
                </td>
                <td>
                  <div className="predictedScore_ d-flex">
                    {dat.subject.predictedOutcome !== "" ? (<span className="predictedScoreMarking_" style={{ backgroundColor: dat.subject.predictedOutcome.charAt(1).toUpperCase() === "G" ? "var(--greater-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "E" ? "var(--expected-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "W" ? "var(--emerging-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "B" ? "var(--below-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "A" ? "var(--absent-colour)" : "#A8A7A7" }}><span className="predictedScoreMarkinText">{dat.subject.predictedOutcome.substr(0, 2)}</span></span>) : (<span className="predictedScoreMarking_" style={{ backgroundColor: "#A8A7A7" }}><span className="predictedScoreMarkinText">-</span></span>)}<span className="predictedScorePercentage">{Math.round(dat.subject.predicted)}%</span>
                  </div>
                </td>
              </td>
              <td colSpan={2}>
                <td className="tableData">
                  <div className="currentScore_ justify-content-center">
                    <span className="currentScorePercentage_">{Math.round(dat.subject.actualKPI)}%</span>
                  </div>
                </td>
                <td>
                  <div className="predictedScore_ d-flex">
                    {dat.subject.predictedKpiOutcome !== "" ? (<span className="predictedScoreMarking_" style={{ backgroundColor: dat.subject.predictedKpiOutcome.charAt(1).toUpperCase() === "G" ? "var(--greater-colour)" : dat.subject.predictedKpiOutcome.charAt(1).toUpperCase() === "E" ? "var(--expected-colour)" : dat.subject.predictedKpiOutcome.charAt(1).toUpperCase() === "W" ? "var(--emerging-colour)" : dat.subject.predictedKpiOutcome.charAt(1).toUpperCase() === "B" ? "var(--below-colour)" : dat.subject.predictedKpiOutcome.charAt(1).toUpperCase() === "A" ? "var(--absent-colour)" : "#A8A7A7" }}><span className="predictedScoreMarkinText">{dat.subject.predictedKpiOutcome.substr(0, 2)}</span></span>) : (<span className="predictedScoreMarking_" style={{ backgroundColor: "#A8A7A7" }}><span className="predictedScoreMarkinText">-</span></span>)}<span className="predictedScorePercentage">{Math.round(dat.subject.predictedKPI)}%</span>
                  </div>
                </td>
              </td>
              <td>
                {dat.year>2 &&<td className="tableData">
                  <td className="classHomeSubject-td">
                    <div className="KS-containerBox">
                      {dat.ksResult !== "" ? (<div className="greenPointer_" style={{ backgroundColor: dat.ksResult.charAt(dat.ksResult.length - 1).toUpperCase() === "M" ? "var(--expected-colour)" : dat.ksResult.charAt(dat.ksResult.length - 1).toUpperCase() === "L" ? "var(--emerging-colour)" : dat.ksResult.charAt(dat.ksResult.length - 1).toUpperCase() === "H" ? "var(--greater-colour)" : dat.ksResult.charAt(dat.ksResult.length - 1).toUpperCase() === "B" ? "var(--below-colour)" : "#A8A7A7" }}></div>) : <div className="greenPointer_" style={{ backgroundColor: "#A8A7A7" }}></div>}
                      <span className="KS1">{dat.ksResult !== "" && dat?.ksResult ? dat.ksResult.toUpperCase() : "-"}</span>
                    </div>
                  </td>
                </td>}
                <td className="tableData">
                  <td className="classHomeSubject-td">
                    <div className="KS-containerBox">
                      <span className="KS1" style={{marginLeft:"20px"}}>{dat.gld ? "true" : "false"}</span>
                    </div>
                  </td>
                </td>
                <td className="tableData">
                  <td className="classHomeSubject-td">
                    <div className="KS-containerBox">
                      {dat.subject.predictedOutcome !== "" ? (<div className="greenPointer_" style={{ backgroundColor: dat.subject.predictedOutcome.charAt(1).toUpperCase() === "G" ? "var(--greater-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "E" ? "var(--expected-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "W" ? "var(--emerging-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "B" ? "var(--below-colour)" : dat.subject.predictedOutcome.charAt(1).toUpperCase() === "A" ? "var(--absent-colour)" : "#A8A7A7" }}></div>) : (<div className="greenPointer_" style={{ backgroundColor: "#A8A7A7" }}></div>)}
                      <span className="KS1">{dat.subject.predictedOutcome === "" ? "-" : dat.subject.predictedOutcome.substr(0, 2)}</span>
                    </div>
                  </td>
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  <div className="markingChipsProgress">
                    {
                      dat.ksResult === "" || dat.subject.predictedOutcome === "" ? (<span className="chips" style={{ backgroundColor: "#A8A7A7" }}>
                        <QuestionMarkOutlinedIcon />
                      </span>) :
                        funCal(dat.ksResult.charAt(dat.ksResult.length - 1).toUpperCase(), dat.subject.predictedOutcome.charAt(1).toUpperCase())
                    }
                  </div>
                </td>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>}</>
  );
}

export { Progress };
